import { DocumentReference } from '.';
import { Gender, Sport } from '../enums';

export class SportLeague {
    id?: string;
    ageGroupList: DocumentReference[];
    displayName: string;
    gender?: Gender;
    genderName: string;
    isActive: boolean;
    isDeleted: boolean;
    isMixedGender: boolean;
    maxMembers: number;
    maxTeams: number;
    minFemale?: number;
    maxMale?: number;
    minMembers: number;
    serviceYear: string;
    sport: Sport;
    sportName: string;
    yearLevelList: DocumentReference[];
    openDate: Date | string;
    closeDate: Date | string;
}
